import jQuery from "jquery";

/**
 * Link items to correct detail location
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  function createDetailLink(elem, slug) {
    let href = elem.href.split("/");
    href.splice(href.length - 1, 0, slug);

    return href.join("/");
  }

  $(".mg-link-group").each(function() {
    let titleLink = this.querySelector(".mg-link-group__title a"),
      summaryLink = this.querySelector("a.mg-link-group__summary-link"),
      fullLink = this.querySelector("a.mg-link-group__full-link"),
      fullOther = this.querySelector("a.mg-link-group__full-other");

    if (fullOther) {
      fullOther.href = createDetailLink(titleLink, "full");
    }

    if (fullLink) {
      fullLink.href = createDetailLink(fullLink, "full");
    }

    if (summaryLink) {
      summaryLink.href = createDetailLink(summaryLink, "summary");
    }
  });
}



// WEBPACK FOOTER //
// ./assets/src/js/components/blurb-items.js